import { render, staticRenderFns } from "./DataListTemp.vue?vue&type=template&id=57b46b8b&"
import script from "./DataListTemp.vue?vue&type=script&lang=js&"
export * from "./DataListTemp.vue?vue&type=script&lang=js&"
import style0 from "./DataListTemp.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports